import styled from 'styled-components';

export const Status = styled.div<{
  iconColor?: string;
  iconBackGroundColor?: string;
}>`
  display: inline-block;
  width: 19px;
  height: 19px;
  border-radius: 12px;
  color: ${p => p.iconColor};
  background-color: ${p => p.iconBackGroundColor};
  margin-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 22px;
  align-self: center;

  i {
    margin-right: 0;
    margin-top: -5px;
  }

  @media screen and (min-width: 640px) {
    line-height: 20px;
  }
`;

export const LinkButton = styled.button`
  color: ${props => props.theme.colors.blue};
  background-color: transparent;
  font-family: inherit;
  cursor: pointer;
  border: none;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const LinkAnchor = styled.a`
  color: ${props => props.theme.colors.blue};
  background-color: transparent;
  font-family: inherit;
  cursor: pointer;
  border: none;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const Section = styled.section<{ knowledgeTest?: boolean }>`
  padding: 24px 0px;
  background-color: ${p => p.theme.colors.white};

  @media screen and (min-width: 640px) {
    padding: 24px 32px;
  }

  @media screen and (min-width: 768px) {
    padding: 24px 48px;
    margin-bottom: 5px;
  }

  @media screen and (min-width: 1024px) {
    padding: ${p => (p.knowledgeTest ? '2px' : '80px')} 80px;
    margin: 0 48px 5px;
  }
`;

export const MessageBox = styled.div`
  color: ${props => props.theme.colors.scaleDarkBlue};
  background-color: ${props => props.theme.colors.scaleLightSky};
`;

export const ChartContainer = styled.div`
  text-align: -webkit-center;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: auto;
  margin-top: auto;
  min-height: 125px;
  position: relative;
`;

export const Score = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: ${props => props.theme.colors.scaleDarkBlue};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
`;

export const HeaderSection = styled.div`
  display: grid;
  justify-content: center;
  margin: 0px auto 0;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
`;

export const PageHeaderWrapper = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  padding-left: 48px;
  padding-right: 24px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  @media screen and (min-width: 768px) {
    margin-top: 64px;
    padding-left: 80px;
    padding-right: 48px;
  }

  @media screen and (min-width: 1280px) {
    padding-right: 80px;
  }
`;
